import * as types from "./actionTypes";
import indienenApi from "../api/indienenApi";
import * as ajax from "./ajaxCounterActions";
import * as exception from "./exceptionActions";
import * as constants from "../constants/DomainConstants";
import * as beads from "./beadActions";

// ----------------------------------------------------------------------------
export function indienenLoaded(indienen) {
	return {
		type: types.INDIENEN_LOADED,
		body: indienen
	};
}

export function loadIndienen(dossierId) {
	return function (dispatch) {
		dispatch(ajax.started());

		return indienenApi.get(dossierId)
			.then(response => {
				return handleIndienenResponse(dispatch, response.data);
			}).catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function confirmIndienen(dossierId) {
	return function (dispatch) {
		dispatch(ajax.started());

		return indienenApi.confirm(dossierId)
			.then(response => {
				return handleIndienenResponse(dispatch, response.data);
			}).catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
			});
	};
}

export function generatePdf(dossierId) {
	return function (dispatch) {
		dispatch(ajax.started());

		return indienenApi.generatePdf(dossierId)
			.then(response => {
				dispatch(ajax.ended());
				//dispatch(projectLoaded(response.data.item, response.data.validationResults));
				dispatch(beads.beadsLoaded(response.data.item.beadModels));
				return true;
			})
			.catch(error => {
				dispatch(ajax.failed(error));
				dispatch(exception.throwException(error));
				return false;
			});
	};
}


function handleIndienenResponse(dispatch, data) {
	dispatch(ajax.ended());
	dispatch(indienenLoaded(data));
	dispatch(beads.beadsLoaded(data.beadModels));

	let isIngediend;
	if (data.status == constants.REDEN_VAN_STATUS_INGEDIEND)
		isIngediend = true;
	else
		isIngediend = false;

	return isIngediend;
}